import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
/**
 * Creates a named context consumer component by invoking the useContext hook
 * @param name name of the consumer component
 * @param useContext hook to provide the context object
 * @returns context consumer component
 */
export function createNamedConsumer(name, useContext) {
    const Consumer = memo(({ children }) => _jsx(_Fragment, { children: children(useContext()) }));
    Consumer.displayName = name;
    return Consumer;
}
//# sourceMappingURL=createNamedConsumer.js.map